import Vue from 'vue'
import store from '@/store'

let menu = new Vue ({
  data: {
    elementos: [
      {
        seccion: 1,
        titulo: "Inicio",
        icono: "mdi-home",
        ruta: "/panel/#",
        componente: () => import(`@/pages/Inicio.vue`),
      },
      {
        seccion: 2,
        titulo: "Estado de cargadores",
        icono: "mdi-gauge",
        ruta: "/panel/estadoCargadores",
        componente: () => import(`@/pages/EstadoCargadores.vue`),
      },
      {
        seccion: 2,
        titulo: "Solicitudes de carga",
        icono: "mdi-car-electric",
        ruta: "/panel/solicitudesDeCarga",
        componente: () => import(`@/pages/SolicitudesDeCarga.vue`),
      },
      {
        seccion: 2,
        titulo: "Histórico de cargas",
        icono: "mdi-archive",
        ruta: "/panel/historicoCargas",
        componente: () => import(`@/pages/HistoricoCargas.vue`),
      },
      {
        seccion: 3,
        titulo: "Registro de auditoría",
        icono: "mdi-clipboard-search-outline",
        ruta: "/panel/registroAuditoria",
        atributoRolOperadorNecesario: "regaud",
        componente: () => import(`@/pages/RegistroAuditoria.vue`),
      },
      {
        seccion: 3,
        titulo: "Configurar",
        icono: "mdi-cog-outline",
        menu: "configurar",
      },
          {
            seccion: 14,
            titulo: "Cargadores",
            icono: "mdi-ev-station",
            ruta: "/panel/gestionCargadores",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "gescar",
            componente: () => import(`@/pages/GestionCargadores.vue`),
          },
          {
            seccion: 14,
            titulo: "APIs de cargadores",
            icono: "mdi-api",
            ruta: "/panel/gestionAPIsCargadores",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "gesapicar",
            componente: () => import(`@/pages/GestionAPIsCargadores.vue`),
          },
          {
            seccion: 14,
            titulo: "Aparcamientos",
            icono: "mdi-file-powerpoint-box",
            ruta: "/panel/gestionInstalaciones",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "visconins",
            componente: () => import(`@/pages/GestionInstalaciones.vue`),
          },
          {
            seccion: 15,
            titulo: "Operadores",
            icono: "mdi-account-key",
            ruta: "/panel/gestionOperadores",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "gesope",
            componente: () => import(`@/pages/GestionOperadores.vue`),
          },
          {
            seccion: 15,
            titulo: "Roles de operador",
            icono: "mdi-account-details",
            ruta: "/panel/gestionRolesOperador",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "gesrolope",
            componente: () => import(`@/pages/GestionRolesOperador.vue`),
          },
          {
            seccion: 16,
            titulo: "Parámetros de configuración",
            icono: "mdi-application-cog",
            ruta: "/panel/parametrosConfiguracion",
            cuelgaDeMenu: "configurar",
            atributoRolOperadorNecesario: "gesparcon",
            componente: () => import(`@/pages/GestionParametrosConfiguracion.vue`),
          },
      {
        seccion: 9,
        titulo: "Mantenimiento",
        icono: "mdi-wrench-outline",
        menu: "mantenimiento",
      },
          {
            seccion: 16,
            titulo: "Estado del sistema",
            icono: "mdi-comment-check-outline",
            ruta: "/panel/estadoSistema",
            cuelgaDeMenu: "mantenimiento",
            atributoRolOperadorNecesario: "regaud",
            componente: () => import(`@/pages/EstadoSistema.vue`),
          },
          {
            seccion: 16,
            titulo: "Consola de SQL",
            icono: "mdi-database",
            ruta: "/panel/consolaSQL",
            cuelgaDeMenu: "mantenimiento",
            atributoRolOperadorNecesario: "gesparcon",
            componente: () => import(`@/pages/ConsolaSQL.vue`),
          }
    ]
  },
  methods: {
    obtenerElementoRuta (rutaElemento) {
      return this.elementos.find (elemento => this.rutaSinHash (elemento.ruta) == rutaElemento);
    },
    procedeNavegarAElemento (elemento) {
      let procede = true;
      procede &= (elemento.parametroConfiguracionRequerido ? this.$parametros_configuracion [elemento.parametroConfiguracionRequerido] : true);
      procede &= (elemento.atributoRolOperadorNecesario ? store.operador.atributosRol.includes (elemento.atributoRolOperadorNecesario) : true);
      return procede;
    },
    procedeMostrarElemento (elemento) {
      let procede = this.procedeNavegarAElemento (elemento);
      procede &= (elemento.visible !== undefined ? elemento.visible : true);
      return procede;
    },
    elementosQueProcedeMostrar() {
      return this.elementos.filter((elemento) => this.procedeMostrarElemento (elemento));
    },
    arbolOpcionesMenu() {
      let elementosMenu = this.elementosQueProcedeMostrar();
      let array = [];

      elementosMenu.forEach ((e1) => {
        if (!e1.cuelgaDeMenu) {
          let aux = {...e1};
          if (aux.menu) {
            aux.elementos = [];
            elementosMenu.forEach ((e2) => {
              if (e2.cuelgaDeMenu == aux.menu)
                aux.elementos.push ({...e2});
            });
            if (aux.elementos.length > 0)
              array.push (aux);
          } else {
            array.push (aux);
          }
        }
      });
      return array;
    },
    rutaSinHash (ruta) {
      if (ruta && ruta.endsWith ('#'))
        return ruta.slice (0, -1);
      else
        return ruta;
    },
    arrayRutasPanel() {
      let array = [];

      this.elementos.forEach ((elemento) => {
        if (elemento.ruta)
          array.push ({
            path: this.rutaSinHash (elemento.ruta),
            component: elemento.componente,
            meta: { elementoMenu: elemento }
          });
      });

      return [{
        path: '/panel',
        meta: {
          name: 'Vista del panel',
        },
        component: () => import(`@/views/VistaPanel.vue`),
        children: array
      }];
    },
    aplicarTraducciones() {
      this.elementos.forEach ( (elemento) => {
        elemento.titulo = this.$t (elemento.titulo);
      });
    }
  }
});

export default menu;